import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { GoverningJurisdictionTypeId } from '../../../../../models/enum/shared/governing-jurisdiction-type-id';
import { SpousalWaiverAttachment } from '../../../../../models/submissions/spousal-waiver-attachment';
import { TrackByUtils } from '../../../../../utils/track-by-utils';

@Component({
  selector: 'app-vb-config-submission-details-spousal-waiver-card',
  templateUrl: './vb-config-submission-details-spousal-waiver-card.component.html',
  styleUrls: ['./vb-config-submission-details-spousal-waiver-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbConfigSubmissionDetailsSpousalWaiverCardComponent {
  @Input({ required: true }) jurisdictionId!: GoverningJurisdictionTypeId;
  @Input() waivers: SpousalWaiverAttachment[] = [];

  public trackById = TrackByUtils.trackById;
}
